import autosize from "autosize";

document.addEventListener("turbo:load", () => {
  autosize(document.querySelectorAll("textarea"));
});
